import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="max-w-[1000px] mx-auto px-6 lg:px-12 py-28 text-center" data-testid="not-found">
      <div className="overline text-ink-soft">{t("notFound.kicker")}</div>
      <h1 className="font-display text-6xl sm:text-7xl tracking-tighter font-bold text-ink mt-4 leading-none">
        {t("notFound.title1")}<br />{t("notFound.title2")}
      </h1>
      <p className="text-ink-soft mt-6">{t("notFound.text")}</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 mt-8 bg-ink text-white px-6 py-3 text-sm font-medium rounded-sm hover:bg-[#112240]"
      >
        {t("notFound.btn")} <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
      </Link>
    </div>
  );
}
